// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-container[data-v-1ec18324] {\n  white-space: nowrap;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.scroll-container[data-v-1ec18324] .el-scrollbar__bar {\n  bottom: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
